<template>
  <header id="header" class="l-header" v-show="showHeaderRouteCheck()">
    <div class="header-top">
      <div class="header-top-inner">
        <h1 class="logo only-mo">
          <a href="/paintpro/main" title="홈">
            <span class="sr-only">NOROO</span>
          </a>
        </h1>
        <div class="user-area">
          <span class="user-name">{{ data.page.userLoginInfo?.zbpName }} </span
          >님, 안녕하세요
        </div>
        <div
          class="c-dropbox"
          v-if="
            data.page.userLoginInfo?.empList?.length > 0 &&
            data.page.empIndex < data.page.userLoginInfo?.empList?.length
          "
        >
          <!-- D: data가 1개일 때 클래스, disabled 추가 -->
          <button
            :class="[
              'drop-btn',
              {
                'is-onething': data.page.userLoginInfo?.empList.length === 1,
              },
            ]"
            type="button"
            :disabled="data.page.userLoginInfo?.empList.length === 1"
            :data-selected="
              '담당영업사원 ' +
              data.page.userLoginInfo?.empList[data.page.empIndex].zbezei +
              ' ' +
              data.page.userLoginInfo?.empList[data.page.empIndex].zempName +
              (data.page.userLoginInfo?.empList[data.page.empIndex]
                .zpositionName || '')
            "
            :data-manager-phone="
              data.page.userLoginInfo?.empList[data.page.empIndex].zphoneNo
            "
            @click="btnCmd('isSaleEmpLayer')"
          >
            <span class="manager"
              >담당영업사원
              {{
                data.page.userLoginInfo?.empList[data.page.empIndex].zbezei +
                " " +
                data.page.userLoginInfo?.empList[data.page.empIndex].zempName +
                (data.page.userLoginInfo?.empList[data.page.empIndex]
                  .zpositionName || "")
              }}</span
            >
            <span class="manager-phone">{{
              data.page.userLoginInfo?.empList[data.page.empIndex].zphoneNo
            }}</span>
          </button>
          <ul
            :class="
              data.popup.isSaleEmpLayer ? 'drop-menu' : 'drop-menu hidden'
            "
          >
            <li
              v-for="(item, idx) in data.page.userLoginInfo?.empList"
              :key="idx"
            >
              <button
                type="button"
                :data-value="
                  '담당영업사원 ' +
                  item.zbezei +
                  ' ' +
                  item.zempName +
                  item.zpositionName
                "
                data-phone="010-222-2222"
                @click="btnCmd('saleEmpSelect', { index: idx })"
              >
                <span class="manager"
                  >담당영업사원 {{ item.zbezei }} {{ item.zempName
                  }}{{ item.zpositionName }}
                </span>
                <span class="manager-phone">{{ item.zphoneNo }}</span>
              </button>
            </li>
          </ul>
        </div>
        <div class="utill">
          <a href="javascript:void(0);" @click="btnCmd('isAlimLayer')">
            <i class="c-icon icon-notification size-medium"></i>
            <span class="text">알림</span>
            <div class="c-count" v-if="isAlimCount">
              <span>{{ dispAlimCount }}</span>
            </div>
          </a>
          <router-link
            :to="{
              name: '/paintpro/utility',
              query: {},
            }"
          >
            <i class="c-icon icon-myinfo size-medium"></i>
            <span class="text">내정보</span>
          </router-link>
          <router-link
            :to="{
              name: '/paintpro/myRoom',
              query: {},
            }"
          >
            <i class="c-icon icon-home size-medium"></i>
            <span class="text">마이룸</span>
          </router-link>
          <template v-if="store.useAuthStore().user">
            <a href="javascript:void(0);" @click="btnCmd('logout')">
              <i class="c-icon icon-logout size-medium"></i>
              <span class="text">로그아웃</span>
            </a>
          </template>
        </div>
      </div>
    </div>
    <div class="header-btm">
      <div class="header-btm-inner">
        <h1 class="logo">
          <a href="/paintpro/main" title="홈">
            <span class="sr-only">NOROO</span>
          </a>
        </h1>
        <nav id="gnb" class="gnb">
          <ul>
            <!-- D: mo에서만 노출 -->
            <li class="gnb-item only-mo">
              <a
                href="javascript:void(0);"
                @click="
                  btnCmd('routerPush', {
                    path: '/paintpro/main',
                    query: {},
                  })
                "
                class="anchor"
                >홈</a
              >
            </li>
            <li
              class="gnb-item"
              :class="{
                'is-active': ['/paintpro/prodList'].includes(useRoute().path),
              }"
            >
              <!-- D: 현재 카테고리 is-active -->
              <a
                href="javascript:void(0);"
                @click="
                  btnCmd('routerPush', {
                    path: '/paintpro/prodList',
                    query: {},
                  })
                "
                class="anchor"
                >제품주문
              </a>
              <ul class="depth">
                <li>
                  <a
                    href="javascript:void(0);"
                    @click="
                      btnCmd('routerPush', {
                        path: '/paintpro/prodList',
                        query: {},
                      })
                    "
                    :class="[
                      {
                        'is-active': ['/paintpro/prodList'].includes(
                          useRoute().path
                        ),
                      },
                    ]"
                    >건축/공업/자보
                  </a>
                </li>
              </ul>
            </li>
            <li
              class="gnb-item"
              :class="[
                {
                  'is-active': [
                    '/paintpro/orderList',
                    '/paintpro/orderList/purchaseList',
                    '/paintpro/orderList/shipmentList',
                  ].includes(useRoute().path),
                },
              ]"
            >
              <a
                href="javascript:void(0);"
                @click="
                  btnCmd('routerPush', {
                    path: '/paintpro/orderList',
                    query: {},
                  })
                "
                class="anchor"
                >주문현황
              </a>
              <ul class="depth">
                <li>
                  <a
                    href="javascript:void(0);"
                    @click="
                      btnCmd('routerPush', {
                        path: '/paintpro/orderList',
                        query: {},
                      })
                    "
                    :class="[
                      {
                        'is-active': ['/paintpro/orderList'].includes(
                          useRoute().path
                        ),
                      },
                    ]"
                    >주문내역
                  </a>
                </li>
                <li>
                  <a
                    href="javascript:void(0);"
                    @click="
                      btnCmd('routerPush', {
                        path: '/paintpro/orderList/shipmentList',
                        query: {},
                      })
                    "
                    :class="[
                      {
                        'is-active': [
                          '/paintpro/orderList/shipmentList',
                        ].includes(useRoute().path),
                      },
                    ]"
                    >출고현황
                  </a>
                </li>
                <li>
                  <a
                    href="javascript:void(0);"
                    @click="
                      btnCmd('routerPush', {
                        path: '/paintpro/orderList/purchaseList',
                        query: {},
                      })
                    "
                    :class="[
                      {
                        'is-active': [
                          '/paintpro/orderList/purchaseList',
                        ].includes(useRoute().path),
                      },
                    ]"
                    >매입현황
                  </a>
                </li>
              </ul>
            </li>
            <li
              class="gnb-item"
              :class="[
                {
                  'is-active': [
                    '/paintpro/colorCombinList',
                    '/paintpro/colorCombinList/updateList',
                    '/paintpro/colorCombinList/colorSearch',
                    '/paintpro/colorCombinList/munsellColorSearch',
                    '/paintpro/colorCombinList/aiColormatching',
                  ].includes(useRoute().path),
                },
              ]"
            >
              <a
                href="javascript:void(0);"
                @click="
                  btnCmd('routerPush', {
                    path: '/paintpro/colorCombinList',
                    query: {},
                  })
                "
                class="anchor"
                >조색배합
              </a>
              <ul class="depth">
                <li>
                  <a
                    href="javascript:void(0);"
                    @click="
                      btnCmd('routerPush', {
                        path: '/paintpro/colorCombinList',
                        query: {},
                      })
                    "
                    :class="[
                      {
                        'is-active': ['/paintpro/colorCombinList'].includes(
                          useRoute().path
                        ),
                      },
                    ]"
                    >조색배합문의
                  </a>
                </li>
                <li>
                  <a
                    href="javascript:void(0);"
                    @click="
                      btnCmd('routerPush', {
                        path: '/paintpro/colorCombinList/updateList',
                        query: {},
                      })
                    "
                    :class="[
                      {
                        'is-active': [
                          '/paintpro/colorCombinList/updateList',
                        ].includes(useRoute().path),
                      },
                    ]"
                    >업데이트
                  </a>
                </li>
                <li>
                  <a
                    href="javascript:void(0);"
                    @click="
                      btnCmd('routerPush', {
                        path: '/paintpro/colorCombinList/colorSearch',
                        query: {},
                      })
                    "
                    :class="[
                      {
                        'is-active': [
                          '/paintpro/colorCombinList/colorSearch',
                        ].includes(useRoute().path),
                      },
                    ]"
                    >색상찾기
                  </a>
                </li>
                <li>
                  <a
                    href="javascript:void(0);"
                    @click="
                      btnCmd('routerPush', {
                        path: '/paintpro/colorCombinList/munsellColorSearch',
                        query: {},
                      })
                    "
                    :class="[
                      {
                        'is-active': [
                          '/paintpro/colorCombinList/munsellColorSearch',
                        ].includes(useRoute().path),
                      },
                    ]"
                    >컬러코드찾기
                  </a>
                </li>
                <li>
                  <a
                    href="javascript:void(0);"
                    @click="
                      btnCmd('routerPush', {
                        path: '/paintpro/colorCombinList/aiColormatching',
                        query: {},
                      })
                    "
                    :class="[
                      {
                        'is-active': [
                          '/paintpro/colorCombinList/aiColormatching',
                        ].includes(useRoute().path),
                      },
                    ]"
                    >NOROO SMART MIX
                  </a>
                </li>
              </ul>
            </li>
            <li
              class="gnb-item"
              :class="[
                {
                  'is-active': [
                    '/paintpro/custCenterList',
                    '/paintpro/custCenterList/reqList',
                    '/paintpro/custCenterList/noticeList',
                  ].includes(useRoute().path),
                },
              ]"
            >
              <a
                href="javascript:void(0);"
                @click="
                  btnCmd('routerPush', {
                    path: '/paintpro/custCenterList',
                    query: {},
                  })
                "
                class="anchor"
                >고객센터
              </a>
              <ul class="depth">
                <li>
                  <a
                    href="javascript:void(0);"
                    @click="
                      btnCmd('routerPush', {
                        path: '/paintpro/custCenterList',
                        query: {},
                      })
                    "
                    :class="[
                      {
                        'is-active': ['/paintpro/custCenterList'].includes(
                          useRoute().path
                        ),
                      },
                    ]"
                    >자주찾는질문
                  </a>
                </li>
                <li>
                  <a
                    href="javascript:void(0);"
                    @click="
                      btnCmd('routerPush', {
                        path: '/paintpro/custCenterList/reqList',
                        query: {},
                      })
                    "
                    :class="[
                      {
                        'is-active': [
                          '/paintpro/custCenterList/reqList',
                        ].includes(useRoute().path),
                      },
                    ]"
                    >1:1 문의
                  </a>
                </li>
                <li>
                  <a
                    href="javascript:void(0);"
                    @click="
                      btnCmd('routerPush', {
                        path: '/paintpro/custCenterList/noticeList',
                        query: {},
                      })
                    "
                    :class="[
                      {
                        'is-active': [
                          '/paintpro/custCenterList/noticeList',
                        ].includes(useRoute().path),
                      },
                    ]"
                    >공지사항
                  </a>
                </li>
              </ul>
            </li>
          </ul>
        </nav>
        <a href="/paintpro/main" class="paint-pro">
          <span class="sr-only">paint-pro</span>
        </a>
      </div>
    </div>
    <div class="bg-menu hidden"></div>
  </header>
  <AlimPop
    v-if="data.popup.isAlimLayer"
    @close="() => (data.popup.isAlimLayer = false)"
  />
</template>

<script setup name="header1">
import { reactive, onMounted, watch, computed, onBeforeUnmount } from "vue";
import { useRouter, useRoute } from "vue-router";
import AlimPop from "@/components/paintpro/utility/alimPop.vue";
import * as store from "@/store";
import * as cmApi from "@/api/cmApi";
import * as cmUtil from "@/utils/cmUtil.js";
const { isMobile } = cmUtil.useDeviceType();
const router = useRouter();
const route = useRoute();

const data = reactive({
  isModalVisible: false,
  page: {
    token: "",
    isLogin: false,
    userLoginInfo: {
      empList: [],
    },
    empIndex: 0,
  },
  popup: {
    isAlimLayer: false,
    isSaleEmpLayer: false,
  },
  eventBus: {
    salesPersonIndex: 0,
    menu: { menu1: "", menu2: "" },
  },
  toolbar: {
    alimCount: 0,
  },
});

watch(
  () => store.useAlimCountStore().alimCount,
  (newValue) => {
    data.toolbar.alimCount = newValue;
  }
);

watch(
  () => store.useAuthStore()?.user,
  (newValue) => {
    if (newValue) {
      data.page.userLoginInfo = newValue;
      data.page.isLogin = newValue ? true : false;
      const pidx = cmUtil.getLocalStorage("gv.salesPersonIndex");
      if (pidx && pidx > 0) {
        if (pidx >= 0 && data.page.userLoginInfo?.empList?.length > pidx) {
          store.useEventBusStore().setSalesPersonIndex(pidx);
        }
      }
    }
  }
);

watch(
  () => store.useEventBusStore()?.salesPersonIndex,
  (newValue) => {
    data.eventBus.salesPersonIndex = newValue;
    if (newValue >= 0 && data.page.userLoginInfo?.empList?.length > newValue) {
      data.page.empIndex = newValue;
    }
  }
);

// watch(
//   () => store.useEventBusStore()?.menu,
//   (newValue) => {
//     data.eventBus.menu = newValue;
//   }
// );

const isMatchRouteMultiple = (route, paths = []) => {
  // '/'는 정확히 일치할 때만 true 반환
  if (route.path === "/") {
    return paths.includes("/");
  }

  // 주문현황,
  if (route.path === "/paintpro/orderList") {
    return paths.includes("/paintpro/orderList");
  }

  // 나머지 경로는 includes로 체크
  return paths.some((path) => {
    // '/'는 제외하고 체크
    if (path === "/") return false;
    if (path === "/paintpro/orderList") return false;
    return route.path.includes(path);
  });
};
const showHeaderRouteCheck = () => {
  /* MEMO
    1. MO에서도 헤더 노출해야하는 경우는 isMobie 조건에 추가
    1. MO에서 헤더 비노출, historyBack 나와야하면 외 조건에 추가
  */

  return isMobile.value
    ? isMatchRouteMultiple(route, [
        "/paintpro/main",
        "/paintpro/prodList",
        "/paintpro/myRoom",
        "/paintpro/orderList",
        "/paintpro/orderList/shipmentList",
        "/paintpro/orderList/purchaseList",
        "/paintpro/colorCombinList",
        "/paintpro/colorCombinmixedInq",
        "/paintpro/custCenterList",
      ])
    : isMatchRouteMultiple(route, [
        "/paintpro/main",
        "/paintpro/prodList",
        "/paintpro/myRoom",
        "/paintpro/orderList",
        "/paintpro/orderList/shipmentList",
        "/paintpro/orderList/purchaseList",
        "/paintpro/colorCombinList",
        "/paintpro/colorCombinmixedInq",
        "/paintpro/custCenterList",
        "/paintpro/orderBasket",
        "/paintpro/orderOrder",
        "/paintpro/orderList/detail",
        "/paintpro/search",
        "/paintpro/quickMenu/rcentlyViewedProd",
        "/paintpro/utility",
      ]);
};

// 알림 존재여부
const isAlimCount = computed(() => {
  return data.toolbar.alimCount > 0 ? true : false;
});
// 알림 표시
const dispAlimCount = computed(() => {
  return data.toolbar.alimCount > 99 ? "99+" : data.toolbar.alimCount;
});

/**********************
 * 마운트
 *********************/
onMounted(() => {
  //data.eventBus.menu = store.useEventBusStore();
  window.addEventListener("click", handleClickOutside);
});

onBeforeUnmount(() => {
  window.removeEventListener("click", handleClickOutside);
});

/**********************
 * 버튼 클릭 모음
 *********************/
async function btnCmd(cmd = "", parms = {}) {
  if (cmd === "isAlimLayer") {
    data.popup.isAlimLayer = !data.popup.isAlimLayer;
  } else if (cmd === "isSaleEmpLayer") {
    data.popup.isSaleEmpLayer = !data.popup.isSaleEmpLayer;
  } else if (cmd === "saleEmpSelect") {
    const _list = data.page.userLoginInfo?.empList;
    cmApi.updateUserPersonInfo({
      type: "saleEmpSelect",
      chcZempNo: _list[parms.index]?.kunn2,
    });

    data.popup.isSaleEmpLayer = false;
    data.page.empIndex = parms.index;
    store.useEventBusStore().setSalesPersonIndex(data.page.empIndex);
  } else if (cmd === "routerPush") {
    router.push({
      path: parms.path,
      query: parms.query,
    });
  } else if (cmd === "logout") {
    //cmApi.logout();
    // router.push({
    //   path: "/logout",
    // });
    //cmApi.logout();
    location.href = "/logout";
  } else {
    alert(`[개발확인] btnCmd() cmd [${cmd}] 를 확인해주세요` + parms);
    return false;
  }
}

/**********************
 * 레이어 바깥 클릭시 종료시키기
 * - 선택항목 및 메뉴목록 바깥쪽 클릭시 호출됨
 * - 선택항목 및 메뉴목록 객체 클래스 범위에 벗어나면 레이어를 닫는다.
 *********************/
function handleClickOutside(e) {
  if (data.popup.isSaleEmpLayer) {
    if (!e.target.closest(".drop-btn")) {
      if (!e.target.closest(".drop-menu")) {
        data.popup.isSaleEmpLayer = false; // 레이어 닫기
      }
    }
  }
}
</script>

<style scoped>
.is-active {
  color: #2cb693;
}
</style>
